export const REFUND_PATH = "/refund-form";
export const LOGIN_PATH = "/login";
